module.exports = __webpack_public_path__ + "static/media/trellis-standard.d6ad744f.png";